// GA4 loads only when a Measurement ID is set in Settings; admin pages are never tracked.
let active = null;

export const initAnalytics = (id) => {
  if (active || !/^G-[A-Z0-9]{4,15}$/.test(id || "")) return;
  active = id;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments); // eslint-disable-line prefer-rest-params
  };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false, anonymize_ip: true });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
};

export const track = (name, params = {}) => {
  if (active && window.gtag) window.gtag("event", name, params);
};
